import { Box, Divider, Stack, useTheme } from '@mui/material';
import { LogoIfx } from '#features/common/components/icons/LogoIfx';
import { NotificationsMenuButton } from '#features/notifications/components/NotificationsMenuButton';
import { useNotificationsCount } from '#features/notifications/derived-state';
import { SettingsMenuButton } from '#features/settings/components/SettingsMenu';
import { WebSmartBar } from '#features/smart-bar/components/web/WebSmartBar';
import { scaleConstant } from '#features/theme/helpers';
import { withSubscribe } from '#lib/withSubscribe';
import { HeaderLogo } from '../shared/HeaderLogo';
import { HeaderLogotype } from '../shared/HeaderLogotype';
import { useWebPlatformDimensions } from './useWebPlatformDimensions';

// where do I put this?
const FlexibleSpace = () => <Box sx={{ flexGrow: 1 }} />;

const logoTypeComfortableHeight = 9;
const logoTypeComfortableWidth = 108;

export const Header = withSubscribe(() => {
  const theme = useTheme();
  const { headerHeight } = useWebPlatformDimensions();
  const notificationCount = useNotificationsCount();
  const { density } = theme.currentModes;

  return (
    <Box
      sx={(theme) => ({
        gap: theme.ifx.spacing['spacing-xxs'],
        height: headerHeight,
        width: '100%',
        bgcolor: theme.ifx.palette['Colors/Background/bg-primary_alt'],
        display: 'flex',
        alignItems: 'center',
        px: theme.ifx.spacing['spacing-sm'],
      })}
    >
      <HeaderLogotype
        sx={{ display: { xs: 'none', sm: 'block' } }}
        height={scaleConstant(logoTypeComfortableHeight, density)}
        width={scaleConstant(logoTypeComfortableWidth, density)}
      />
      <HeaderLogo
        sx={{ marginRight: 'auto', pr: theme.ifx.spacing['spacing-md'] }}
      />
      <Divider
        orientation="vertical"
        flexItem
        variant="middle"
        sx={(theme) => ({
          my: theme.ifx.spacing['spacing-md'],
          mr: theme.ifx.spacing['spacing-lg'],
        })}
      />
      <LogoIfx
        sx={{
          width: scaleConstant(63, density),
          height: scaleConstant(12, density),
        }}
      />

      <FlexibleSpace />
      <WebSmartBar
        closeOnClickAway
        sx={{
          marginLeft: 'auto',
          marginRight: 0,
          borderLeft: `1px solid ${theme.ifx.palette['Colors/Border/border-secondary']}`,
          borderRight: `1px solid ${theme.ifx.palette['Colors/Border/border-secondary']}`,
        }}
      />
      <Stack
        direction="row"
        alignItems="center"
        gap={(theme) => theme.ifx.spacing['spacing-xs']}
      >
        {/* hidden until implemented */}
        {/* <ToggleTabsButton /> */}
        <NotificationsMenuButton notificationCount={notificationCount} />
        <SettingsMenuButton />
      </Stack>
    </Box>
  );
});
